var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"programasactivos"},[_c('h1',[_vm._v("programas activos")]),_vm._v(" "),_c('div',{staticClass:"programasactivos-list container -xs"},_vm._l((_vm.programas),function(programa,key){return _c('programa-activo',{key:"key",attrs:{"data":programa}})}),1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-071fd67b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view-parts/home/programas-activos.vue
// module id = null
// module chunks = 